import React, { useEffect, useRef, useState } from 'react';
import { useDispatch, useSelector } from 'react-redux';
import { Link } from 'react-router-dom';
import { menu_bar, selectMenuBar } from '../../redux/features/header-slice';
import { Search } from '../../svg';
import { retrieveToken } from './../../hooks/use-token';

const Sidebar = () => {
  
  const menuOpen = useSelector(selectMenuBar);
  const dispatch = useDispatch();
  const [home, setHome] = useState(false)
  const [courses, setcourses] = useState(false)
  const [blog, setBlog] = useState(false)
  const [pages, setPages] = useState(false)
  const [logged, setLogged] = useState(false);
  
  useEffect(() => {
    
    const tokenApi = retrieveToken();
    
    if (tokenApi)
    setLogged(true);
    
  });
  
  const openMobileMenu = menu => {
    
    if (menu === 'home') {
      setHome(!home)
      setcourses(false)
      setBlog(false)
      setPages(false)
    }
    else if (menu === 'courses') {
      setHome(false)
      setcourses(!courses)
      setBlog(false)
      setPages(false)
    }
    else if (menu === 'blog') {
      setHome(false)
      setcourses(false)
      setBlog(!blog)
      setPages(false)
    }
    else if (menu === 'pages') {
      setHome(false)
      setcourses(false)
      setBlog(false)
      setPages(!pages)
    }
  };
  
  return (
    <>
    <div className={menuOpen ? "sidebar__area open" : "sidebar__area"}>
    <div className="sidebar__wrapper">
    <div className="sidebar__close">
    <button className="sidebar__close-btn" id="sidebar__close-btn"
    onClick={() => dispatch(menu_bar(false))}>
    <span><i className="far fa-times"></i></span>
    <span>close</span>
    </button>
    </div>
    <div className="sidebar__content">
    <div className="logo mb-40">
    <Link to="/"><img src="/assets/img/logo/logo-pri-alterada.png" style={{width: "100px"}} alt="logo" /></Link>
    </div>
    <div className="mm-menu">
    <ul>
    <li className={home ? "has-droupdown active" : "has-droupdown"}>
    <a href='#!' onClick={() => { openMobileMenu('home'); }}>Principal </a>
    <ul className={home ? "sub-menu active" : "sub-menu"} onClick={() => dispatch(menu_bar(false))}>
    <li><Link to="/">Home</Link></li>
    </ul>
    </li>
    <li className={courses ? "has-droupdown active" : "has-droupdown"}>
    <a href='/cursos' onClick={() => { openMobileMenu('courses'); }}>Cursos </a>
    {/* <ul className={courses ? "sub-menu active" : "sub-menu"} onClick={() => dispatch(menu_bar(false))}>
    <li><Link to="/courses">Courses </Link></li>
    <li><Link to="/course-list">Course List</Link></li>
    <li><Link to="/course-sidebar">Course Sidebar</Link></li>
    <li><Link to="/curso-detalhes">Course Details</Link></li>
  </ul> */}
  </li>
  <li className={blog ? "has-droupdown active" : "has-droupdown"}>
  <a href='/#pri' onClick={() => { openMobileMenu('blog'); }}>Conheça a Pri </a>
  {/* <ul className={blog ? "sub-menu active" : "sub-menu"} onClick={() => dispatch(menu_bar(false))}>
  <li><Link to="/blog">Blog</Link></li>
  <li><Link to="/blog-details">Blog Details</Link></li>
</ul> */}
</li>

{!logged && ( <li className={blog ? "has-droupdown active" : "has-droupdown"}>
<Link to='/entrar'>Já sou aluno </Link></li>)}
{!logged && ( <li className={blog ? "has-droupdown active" : "has-droupdown"}>
<Link to='/inscrever-se'>Criar conta</Link></li>)}

{logged && ( <li className={blog ? "has-droupdown active" : "has-droupdown"}>
<Link to='/meu-perfil'>Meus dados</Link></li>)}
{logged && ( <li className={blog ? "has-droupdown active" : "has-droupdown"}>
<Link to='/meus-pagamentos'>Meus pagamentos </Link></li>)}
{logged && ( <li className={blog ? "has-droupdown active" : "has-droupdown"}>
<Link to='/meus-cursos'>Meus cursos </Link></li>)}
{logged && ( <li className={blog ? "has-droupdown active" : "has-droupdown"}>
<Link to='/assistir-mais-tarde'>Assistir mais tarde </Link></li>)}
{logged && ( <li className={blog ? "has-droupdown active" : "has-droupdown"}>
<Link to='/minhas-redacoes'>Minhas redações </Link></li>)}


{/* <li className={pages ? "has-droupdown active" : "has-droupdown"}>
<a href='#!' onClick={() => { openMobileMenu('pages'); }}>Pages </a>
<ul className={pages ? "sub-menu active" : "sub-menu"} onClick={() => dispatch(menu_bar(false))}>
<li><Link to="/about">About</Link></li>
<li><Link to="/instructor">Instructor</Link></li>
<li><Link to="/instructor-details">Instructor Details</Link></li>
<li><Link to="/event-details">Event Details</Link></li>
<li><Link to="/cart">My Cart</Link></li>
<li><Link to="/wishlist">My Wishlist</Link></li>
<li><Link to="/checkout">Checkout</Link></li>
<li><Link to="/entrar">Sign In</Link></li>
<li><Link to="/inscrever-se">Sign Up</Link></li>
<li><Link to="/error">Error</Link></li>
</ul>
</li>
<li onClick={() => dispatch(menu_bar(false))}><Link to="/contact">Contact</Link></li> */}
</ul>
</div>

{/* <div className="sidebar__search p-relative mt-40 ">
<form onSubmit={e => e.preventDefault()}>
<input type="text" placeholder="Search..." />
<button type="submit"><Search /></button>
</form>
</div> */}

</div>
</div>
</div>

{/* <!-- sidebar overlay end --> */}
<div onClick={() => dispatch(menu_bar(false))}
className={`body-overlay ${menuOpen ? 'opened' : ''}`}></div>
{/* <!-- sidebar overlay end --> */}
</>
)
}

export default Sidebar;